interface DialogConfig {
  login: string;
  logout: string;
}

interface AEMConfig {
  routingEnabled: boolean;
  available: boolean;
  userSessionRequired: boolean;
}

export interface b2xlcComponentConfig {
  payload: DialogConfig;
  config: AEMConfig;
}

export enum ButtonStyle {
  primary = 'wb-button--primary',
  secondary = 'wb-button--secondary',
  secondaryTransparent = 'wb-button--secondary wb-button--semi-transparent',
  tertiary = 'wb-button--tertiary',
  small = 'wb-button--small',
  medium = 'wb-button--medium',
  large = 'wb-button--large',
  dark = 'wb-button--theme-dark',
}
